import { render, staticRenderFns } from "./TabNetwork.vue?vue&type=template&id=32386ebf&scoped=true&"
import script from "./TabNetwork.vue?vue&type=script&lang=js&"
export * from "./TabNetwork.vue?vue&type=script&lang=js&"
import style0 from "./TabNetwork.vue?vue&type=style&index=0&id=32386ebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32386ebf",
  null
  
)

export default component.exports